module.exports = __webpack_public_path__ + "staticcomp/img/content_2.bf704c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_2.jpg
// module id = /5rK
// module chunks = 39